import { render, staticRenderFns } from "./HeaderParticipant.vue?vue&type=template&id=5319afa4"
import script from "./HeaderParticipant.vue?vue&type=script&lang=js"
export * from "./HeaderParticipant.vue?vue&type=script&lang=js"
import style0 from "./HeaderParticipant.vue?vue&type=style&index=0&id=5319afa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports